var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38041 11.7704C1.22876 11.9174 1.02308 12 0.808624 12C0.594164 12 0.388487 11.9174 0.236841 11.7704C0.085194 11.6234 1.59786e-09 11.4241 0 11.2162C-1.59786e-09 11.0083 0.085194 10.809 0.236841 10.662L5.04722 6.00065L0.238186 1.33801C0.163098 1.26523 0.103535 1.17883 0.0628981 1.08373C0.0222609 0.988638 0.00134515 0.886718 0.00134515 0.783789C0.00134515 0.68086 0.0222609 0.578939 0.0628981 0.483846C0.103535 0.388752 0.163098 0.302348 0.238186 0.229567C0.313274 0.156785 0.402416 0.0990515 0.500523 0.0596625C0.59863 0.0202734 0.70378 -7.66878e-10 0.80997 0C0.91616 7.66878e-10 1.02131 0.0202734 1.11942 0.0596625C1.21752 0.0990515 1.30667 0.156785 1.38175 0.229567L6.76325 5.44578C6.83842 5.51855 6.89802 5.605 6.93865 5.70015C6.97928 5.7953 7.00012 5.89729 7 6.00027C6.99987 6.10325 6.97878 6.20519 6.93792 6.30025C6.89706 6.39531 6.83725 6.48162 6.7619 6.55422L1.38041 11.7704Z",
    fill: "#23232D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.2ffe338fa85599253547a9c3f7f3a8b7.svg";
export { ForwardRef as ReactComponent };